/*
 * @Description: 优惠券领取页面
 * @Author: maowy
 * @Date: 2020-10-10 14:33:31
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: yyyy-08-Th 10:26:01
*/

import Vue from 'vue'
// import _ from 'lodash'
import {
    mapState,
    mapActions,
} from 'vuex'
import {
    getLoginInfo
} from '../../utils/loginInfo'
import viewName from '../constant.js'
import {
    getCouponInfo,
    getCoupon,
    createBdCouponOrder
} from '@/models/coupon'
import { Loading } from 'vant'
import Footer from '@/components/footer/footer.vue'
import appGuideDialog from '@/components/appGuideDialog/appGuideDialog'
import officialBar from '@/components/officialBar/index.vue'
import { wxShare } from '@/utils/wxsdk'

Vue.use(Loading)

export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.couponDetail,
    components: {
        'fc-footer': Footer,
        appGuideDialog,
        officialBar
    },
    data () {
        return {
            userInfo: getLoginInfo(), // 用户信息
            phone: '',  // 用户手机
            detail: {}, // 优惠券详情信息
            can_use_store_list_str: '', // 门店处理
            longitude: '',
            latitude: '',
            wechat_sstore_id: '', // 小程序门店id
            sstore_id: '', // php门店id
            qrCode: '', // 小程序门店首页二维码
            type: 'bc',
            jumpType: 'couponGoodsList' // 跳转小程序页面
        }
    },
    computed: {
        ...mapState({
            wxUserInfo: ({ appInfo }) => appInfo.wxUserInfo,
            isWeixin: ({ appInfo }) => appInfo.isWeixin,
        }),
        jumpSmallWeChatParams () {
            const obj = {
                user_receive_coupon_id: this.detail['user_receive_coupon_id'] || '',
                wechat_sstore_id: this.detail['wechat_sstore_id'] || '',
                coupon_id: this.coupon_id || '',
                sstore_id: this.sstore_id || '',
                coupon_type: this.type === 'bc' ? '1' : '2',
                is_details: '0'
            }
            return obj
        }
    },
    watch: {
        wxUserInfo (newValue) {
            this.phone = newValue.phone_number
        }
    },
    created () {
        this.$setgoindex()
        // 调取，用于通过code获取用户信息并且保存到本地并且进行绑定手机号码的逻辑
        // this.getWxUserInfo(this.$route.query.code || '').then(_ => {
        //     const _thisPath = this.$route.path
        //     let _thisQuery = this.$route.query
        //     _thisQuery['code'] && delete _thisQuery['code'] && this.$router.replace(`${_thisPath}?${toQueryObject(_thisQuery)}`)
        // })
        this.$emit('setHeader', {
            title: '优惠券',
            showHeader: true,
            showLeft: false
        })
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
        const { coupon_id, type } = this.$route.query
        this.coupon_id = coupon_id
        this.type = type
        this.getData()
    },
    activated () {
    },
    async mounted () {
        this.phone = this.userInfo['phone_mob'] || this.userInfo['phone_number'] || ''
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'getWxUserInfo',
            'verifyUserInfo',
            'postCounponOrderInfo',
            'getLocation',
        ]),
        // 微信分享
        configWxShare (detail) {
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    ...detail
                })
            }
        },
        getData () {
            this.showLoading()
            getCouponInfo({
                coupon_id: this.coupon_id,
                type: this.type
            }).then(res => {
                this.hideLoading()
                this.detail = res
                // 只有bc的时候，跳转小程序功能要带上小程序门店id以及二维码
                if (this.type === 'bc') {
                    this.wechat_sstore_id = res.wechat_sstore_id
                    this.qrCode = res.wechat_qr_code
                    this.sstore_id = res.sstore_id
                }
                // 处理门店
                this.can_use_store_list_str = this.detail.can_use_store_list && this.detail.can_use_store_list.length ? this.detail.can_use_store_list.join('、') : ''
                // 微信分享
                let shareData = {
                    title: res.share.title,
                    desc: res.share.desc,
                    imgUrl: res.share.imgUrl || res.banner
                }
                this.configWxShare(shareData)
            }).catch(() => {
                this.hideLoading()
            })
        },
        // 领取优惠券
        clickGetCoupon () {
            this.verifyUserInfo({
                type: 'back'
            }).then(_ => {
                this.showLoading()
                getCoupon({
                    coupon_id: this.coupon_id,
                    type: this.type
                }).then(res => {
                    this.hideLoading()
                    this.$toast('领取成功')
                    this.detail['is_get'] = 1
                    this.detail['user_receive_coupon_id'] = res.user_receive_coupon_id
                }).catch(() => {
                    this.hideLoading()
                    this.getData() // 重新请求接口
                })
            })
        },
        // bd优惠券抢购
        getBuy () {
            this.verifyUserInfo({
                type: 'back'
            }).then(_ => {
                let params = {
                    coupon_id: this.coupon_id,
                }
                createBdCouponOrder(params)
                    .then(res => {
                        this.$router.push({
                            name: 'chooseToPay',
                            query: {
                                order_id: res.order_id,
                                coupon_id: this.coupon_id,
                                order_type: 'service_bd_coupon',
                            }
                        })
                    })
                    .catch(() => {
                        this.getData() // 重新请求接口
                    })
            })
        },
        // 跳转门店
        getMyLocation (param = {}) {
            this.showLoading()
            // from=mergeSpread,不展示自定义gps提示弹窗
            const options = { timeout: 3000, from: 'noTips' }
            this.getLocation(options).then(this.showPosition).catch(this.showErr).finally(() => {
                this.jumpStoreList(param['receive_id'] && param)
            })
        },
        /* 获取位置信息成功 */
        showPosition ({lng, lat}) {
            this.hideLoading()
            this.longitude = lng
            this.latitude = lat
        },
        /* 获取位置信息失败，定位失败再请求定位，测试使用 */
        showErr () {
            this.hideLoading()
            // this.jumpStoreList()
        },
        jumpStoreList (options) {
            const query = {
                coupon_id: this.coupon_id,
                latitude: this.latitude,
                longitude: this.longitude,
            }
            options && Object.assign(query, options)
            this.$router.push({
                name: 'couponStoreList',
                query
            })
        },
        showTips () {
            if (this.isWeixin) {
                if (this.type === 'bd') {
                    this.getMyLocation({
                        receive_id: this.detail['user_receive_coupon_id'] || '',
                        coupon_type: '2',
                        is_details: '0',
                        showWXbtn: true
                    })
                    return
                }
            }
            this.$refs.appGuideDialog.open()
        },
        // 跳转现在推广合作，需要进行曝光
        goToad () {
            window.location.href = 'https://www.carisok.net/join.html'
        },
        // 跳转固定页面--> 产品叫添加固定的专题。线上环境ID:390
        goSpecialAd () {
            this.$router.push({
                name: 'mergeSpread',
                query: {
                    topic_id: '390'
                }
            })
        }
    },
    destroyed () {
    },
}
